module.exports = ($node) ->
    range = document.createRange()
    range.selectNodeContents($node)
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
    document.execCommand('copy')
    return
